import isNil from 'lodash/isNil';
import noop from 'lodash/noop';
import React, {
  useMemo,
} from 'react';
import ImageIcon from 'core/icons/image';
import NotesIcon from 'core/icons/notes';

type Prop = {
  title: string;
  onClick: () => void;
  date?: string;
  mediaType?: 'note' | 'image' | 'document';
};

export default function PatientMetaData({
  title,
  onClick,
  date,
  mediaType = 'document',
}: Prop) {
  const MediaIcon = useMemo(() => (
    mediaType === 'image' ? ImageIcon : NotesIcon
  ), [mediaType]);

  return (
    <div
      role="button"
      tabIndex={-1}
      onKeyDown={noop}
      onClick={onClick}
      className="flex items-start gap-2 py-2 border-b border-gray-200 last:border-none hover:bg-blue-50 hover:text-blue-500"
    >
      <MediaIcon className="!h-4 !w-4 !text-blue-500" />
      <span className="text-xs font-semibold [word-break:break-word]">{title}</span>
      {!isNil(date) && (
        <span className="text-xs font-normal text-gray-400">
          {`(${date})`}
        </span>
      )}
    </div>
  );
}
